"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payGateOptions = exports.paymentOptions = exports.cardProviders = exports.initialPaymentSettingsValues = exports.initialPayGateValues = void 0;
var payfast_png_1 = __importDefault(require("../../../../../assets/payments/payfast.png"));
var paygate_png_1 = __importDefault(require("../../../../../assets/payments/paygate.png"));
var peach_png_1 = __importDefault(require("../../../../../assets/payments/peach.png"));
var _devMode = process.env.NODE_ENV !== "production";
exports.initialPayGateValues = {
    moto: {
        paygate_id: "",
        encryption_key: "",
        user_name: "",
        password: "",
        company: "",
        type: "MOTO",
    },
    secure: {
        paygate_id: "",
        encryption_key: "",
        user_name: "",
        password: "",
        company: "",
        type: "3D SECURE",
    },
};
var initialPeachValues = {
    entity_id: _devMode ? "entity id testing 04" : "",
    bearer_token: _devMode ? "bearer token testing 04" : "",
    api_key: _devMode ? "api key testing 04" : "",
    client_code: _devMode ? "client code testing 04" : "",
    service: _devMode ? "service testing 04" : "",
    service_type: _devMode ? "service type testing 04" : "",
};
var initialPayfastValues = {
    merchant_id: _devMode ? "testing 05" : "",
    merchant_key: _devMode ? "testing 05" : "",
    merchant_passphrase: _devMode ? "testing 05" : "",
};
exports.initialPaymentSettingsValues = {
    payment_config: {
        third_party: "NONE",
        account_owner: "NONE",
    },
    payment_method: {
        paygate: exports.initialPayGateValues,
        peach: initialPeachValues,
        payfast: initialPayfastValues,
    },
};
exports.cardProviders = ["peach", "paygate"];
exports.paymentOptions = [
    {
        title: "Card",
        selections: [
            { value: "paygate", image: paygate_png_1.default },
            { value: "peach", image: peach_png_1.default },
        ],
    },
    {
        title: "EFT",
        selections: [{ value: "payfast", image: payfast_png_1.default }],
    },
];
exports.payGateOptions = [
    { label: "3D Secure", value: "secure" },
    { label: "Moto", value: "moto" },
];
